/**
 * @param {number} [length=13] - Max string length before ellipsis (default = 13)
 */
const ellipsisString = (value: string, length = 13) =>
  value.length > length ? `${value.substr(0, length - 3)}...` : value

export default ellipsisString
